<template>
<div>
    <div class="row">
        <div :class="['col_12', {'loading_overlay': loading}]">
            <div class="card no_border">
                <div class="card-header">
                    <div class="d_flex_btwn form_action_btn width_full">
                        <div class="card-title">{{ title }}</div>
                        <router-link class="btn btn_blue ml_10" :to="{name: 'settings_promotion'}">{{ $t('common.back') }}</router-link>
                    </div>
                </div>
                <div class="card-body pl_0 pr_0">
                    <div class="row">
                        <div class="col_12">
                            <div :class="['form-group', {'has_error': errorFor('status')}]">
                                <label>{{ $t('common.status') }}</label>
                                <div class="form_inline">
                                    <div class="form_radio">
                                        <input type="radio" id="waiting" value="1" v-model="form.status">
                                        <label for="waiting">{{ $t('common.active') }}</label>
                                    </div>
                                    <div class="form_radio">
                                        <input type="radio" id="posting" value="0" v-model="form.status">
                                        <label for="posting">{{ $t('common.inactive') }}</label>
                                    </div>
                                </div>
                                <v-errors :errors="errorFor('status')" />
                            </div>
                        </div>
                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('promotion_type_id')}]">
                                <label>Promotion Type</label>
                                <select class="form_global" v-model="form.promotion_type_id">
                                    <option v-for="(promotionType, index) in promotionTypes" :key="'promotion_type_id' + index" :value="index">{{ promotionType }}</option>
                                </select>
                                <v-errors :errors="errorFor('promotion_type_id')" />
                            </div>
                        </div>

                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('title')}]">
                                <label>Title</label>
                                <input type="text" v-model="form.title" class="form_global">
                                <v-errors :errors="errorFor('title')" />
                            </div>
                        </div>

                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('is_permanent')}]">
                                <label>Validity</label>
                                <div class="form_inline">
                                    <div class="form_radio">
                                        <input type="radio" id="validityPermanent" name="validity" value="1" v-model="form.is_permanent" @change="isPermanent">
                                        <label for="validityPermanent">Permanent</label>
                                    </div>
                                    <div class="form_radio">
                                        <input type="radio" id="validityPermanentFrom" name="validity" value="0" v-model="form.is_permanent" @change="isPermanent">
                                        <label for="validityPermanentFrom">From</label>
                                    </div>
                                    <div class="display_inline datepicker_wrapper" :class="{'has_error': errorFor('valid_from')}" v-if="form.is_permanent == 0">
                                        <datepicker v-model="form.valid_from" position="left" :format="'yyyy-MM-dd'" @blur="form.valid_from=dateFormat(form.valid_from, 'YYYY-MM-DD')" autoApply :enableTimePicker="false" :clearable="true">
                                        </datepicker>
                                    </div>
                                    <div class="display_inline" v-if="form.is_permanent == 0">
                                        <span class="mr_10">To</span>
                                        <div class="display_inline datepicker_wrapper" :class="{'has_error': errorFor('valid_to')}">
                                            <datepicker v-model="form.valid_to" position="left" :format="'yyyy-MM-dd'" @blur="form.valid_to=dateFormat(form.valid_to, 'YYYY-MM-DD')" autoApply :enableTimePicker="false" :clearable="true">
                                            </datepicker>
                                        </div>
                                    </div>
                                </div>
                                <v-errors :errors="errorFor('valid_from')" />
                                <v-errors :errors="errorFor('valid_to')" />
                                <v-errors :errors="errorFor('is_permanent')" />
                            </div>
                        </div>

                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('coupon_code')}]">
                                <label>Coupon Code</label>
                                <div class="form_inline">
                                    <div class="display_inline">
                                        <input type="text" v-model="form.coupon_code" class="form_global" placeholder="Coupon Code">
                                    </div>
                                    <div class="display_inline">
                                        <button class="btn btn_blue" @click.prevent="form.coupon_code = generateCouponCode()">Generate Coupon Code</button>
                                    </div>
                                </div>

                                <v-errors :errors="errorFor('coupon_code')" />
                                
                                <!-- <div class="form_inline">
                                    <div class="display_inline">
                                        <div class="form_checkbox">
                                            <input type="checkbox" id="has_coupon_code" name="checkbox" v-model="form.has_coupon_code" checked>
                                            <label for="has_coupon_code"></label>
                                        </div>
                                        <v-errors :form-errors="errorFor('has_coupon_code')"></v-errors>
                                    </div>
                                    <template v-if="form.has_coupon_code">
                                        <div class="display_inline">
                                            <input type="text" v-model="form.coupon_code" class="form_global" placeholder="Coupon Code">
                                            <v-errors :form-errors="errorFor('coupon_code')"></v-errors>
                                        </div>
                                        <div class="display_inline">
                                            <button class="btn btn_blue" @click.prevent="form.coupon_code = generateCouponCode()">Generate Coupon Code</button>
                                        </div>
                                    </template>
                                    <v-errors :form-errors="errorFor('coupon_code')"></v-errors>
                                </div> -->
                            </div>
                        </div>

                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('multiple_use')}]">
                                <label>Multiple Use</label>
                                <div class="form_inline">
                                    <div class="form_radio">
                                        <input type="radio" id="mYes" value="1" v-model="form.multiple_use" name="multiple_use">
                                        <label for="mYes">Yes</label>
                                    </div>
                                    <div class="form_radio">
                                        <input type="radio" id="mNo" value="0" v-model="form.multiple_use" name="multiple_use">
                                        <label for="mNo">No</label>
                                    </div>
                                </div>
                                <v-errors :errors="errorFor('multiple_use')" />
                            </div>
                        </div>

                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('all_lecture')}]">
                                <label>Category</label>
                                <div class="form_inline">
                                    <div class="display_inline">
                                        <div class="form_radio">
                                            <input type="radio" id="allCategory" value="1" v-model="form.all_lecture" name="all_lecture">
                                            <label for="allCategory">All Lectures</label>
                                        </div>
                                        <div class="form_radio">
                                            <input type="radio" id="selectedCat" value="0" v-model="form.all_lecture" name="all_lecture">
                                            <label for="selectedCat">Select a lectures</label>
                                        </div>
                                    </div>
                                    <div class="display_inline multi_category" v-if="form.all_lecture == 0">
                                        <div :class="[{'has_error': errorFor('selected_lectures')}]">
                                            <Multiselect v-model="form.selected_lectures" mode="tags" placeholder="Select category" :close-on-select="false" :searchable="true" :create-option="true" :hideSelected="false" :options="packages" />
                                        </div>
                                    </div>
                                    <v-errors :errors="errorFor('selected_lectures')" />
                                </div>
                            </div>
                        </div>

                        <div class="col_3">
                            <div :class="['form-group', {'has_error': errorFor('discount')}]">
                                <label>Discount</label>
                                <div class="form_inline">
                                    <div class="display_inline">
                                        <input type="number" v-model="form.discount" class="form_global" min="0">
                                    </div>
                                    <div class="display_inline" v-if="form.promotion_type_id == 0">
                                        <span>%</span>
                                    </div>
                                </div>
                                <v-errors :errors="errorFor('discount')" />
                            </div>
                        </div>

                        <div class="col_12">
                            <div :class="['form-group', {'has_error': errorFor('description')}]">
                                <label>Description</label>
                                <textarea class="form_global description-textarea" v-model="form.description" name="description" rows="8"></textarea>
                                <v-errors :errors="errorFor('description')" />
                            </div>
                        </div>
                    </div>
                    <div class="d_flex_end form_action_btn">
                        <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                        <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
export default {
    components: {
        Multiselect,
        Datepicker
    },
    data() {
        return {
            title: this.$t('sidebar.promotion.add_promotion'),
            cancelRouteName: 'settings_promotion',
            promotionTypes: [],
            packages: [],
            form: {
                status: 1,
                promotion_type_id: 0,
                title: '',
                description: '',
                is_permanent: 1,
                valid_from: '',
                valid_to: '',
                has_coupon_code: 1,
                coupon_code: '',
                multiple_use: 1,
                all_lecture: 1,
                selected_lectures: [],
                discount: ''
            }
        }
    },
    created() {
        this.axios.get('/promotions/enumeration').then((response) => this.promotionTypes = response.data)

        this.axios.get('/packages')
            .then(response => {
                let packages = response.data.data

                if (packages) {
                    packages.forEach((element) => {
                        var packagesList = {
                            value: element.id,
                            label: element.package_name
                        }
                        
                        this.packages.push(packagesList)
                    });
                }
            });

        if (this.$route.name === 'settings_promotion_edit') {
            this.axios.get('/promotions/' + this.$route.params.id)
                .then((response) => {
                    let promotionData = response.data.data
                    this.form.status = promotionData.status;
                    this.form.promotion_type_id = promotionData.promotion_type_id;
                    this.form.title = promotionData.title;
                    this.form.description = promotionData.description;
                    this.form.is_permanent = promotionData.is_permanent;
                    this.form.valid_from = promotionData.valid_from;
                    this.form.valid_to = promotionData.valid_to;
                    this.form.has_coupon_code = promotionData.has_coupon_code;
                    this.form.coupon_code = promotionData.coupon_code;
                    this.form.multiple_use = promotionData.multiple_use;
                    this.form.discount = promotionData.discount;
                    if (promotionData.services && promotionData.services.length) {
                        let services = [];
                        promotionData.services.forEach((element) => {
                            services.push(element.service_id)
                        });

                        if(services && services.length){
                            this.form.all_lecture = 0
                            this.form.selected_lectures = services
                        }else{
                            this.form.all_lecture = 1
                            this.form.selected_lectures = []
                        }
                    }
                })
            this.title = this.$t('sidebar.promotion.edit_promotion');
        }
    },
    methods: {
        dateFormat(e, format) {
            if (e) {
                return moment(e).format(format)
            }
            return null
        },
        isPermanent() {
            this.form.valid_from = '';
            this.form.valid_to = '';
        },
        generateCouponCode(len = 10) {
            let code = '';
            let possibleChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            for (var i = len; i > 0; i--) {
                code += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
            }
            return code;
        },
        submit() {
            this.allErrors = null;
            this.loading = true;

            if (this.$route.name === 'settings_promotion_edit') {
                this.axios.patch('/promotions/' + this.$route.params.id, this.form)
                    .then(() => {
                        this.$router.push({
                            name: 'settings_promotion'
                        });
                        this.showSuccessMsg(this.$t('common.updateSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.axios.post('/promotions', this.form)
                    .then(() => {
                        this.$router.push({
                            name: 'settings_promotion'
                        });
                        this.showSuccessMsg(this.$t('common.addSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.datepicker_wrapper {
    position: relative;
}

.display_inline {
    display: inline-block;
    margin-right: 10px
}

.multi_category {
    width: 57%;
}
</style>
